/**
 * Pages the learner should see. `hidden` is a flag on the saved record, not a
 * delete: hiding keeps the scene valid and reversible. The player is the only
 * consumer that must skip them, or a hidden page still appears in the nav.
 */
export function visibleScenes<T extends { metadata?: { hidden?: boolean } | null }>(scenes: T[]): T[] {
  return scenes.filter(scene => scene.metadata?.hidden !== true);
}
